const toggleBtn = document.querySelector('.drawer__close');
const drawer = document.getElementById('drawer');
const header = document.querySelector('.lp_wrap header');

const openDrawer = () => {
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  toggleBtn.setAttribute('aria-expanded', 'true');
  toggleBtn.setAttribute('aria-label', 'メニューを閉じる');
  document.body.style.overflow = 'hidden';
};

const closeDrawer = () => {
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  toggleBtn.setAttribute('aria-expanded', 'false');
  toggleBtn.setAttribute('aria-label', 'メニューを開く');
  document.body.style.overflow = '';
};

toggleBtn.addEventListener('click', () => {
  drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
});

drawer.addEventListener('click', (e) => {
  const a = e.target.closest('a');
  if (!a) return;

  const hash = a.getAttribute('href');
  if (!hash || !hash.startsWith('#')) return;

  const target = document.querySelector(hash);
  if (!target) return;

  e.preventDefault();
  closeDrawer();

  setTimeout(() => {
    const headerH = header ? header.getBoundingClientRect().height : 0;
    const y = target.getBoundingClientRect().top + window.pageYOffset - headerH;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, 200);
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
});